import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  TimeScale,
  TimeSeriesScale,
  Title,
  Tooltip,
  Chart,
  Filler,
  Legend,
  BarElement,
  Plugin,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { CHART_COLORS } from "./SolarGikLib/Colors";

export function registerChartJs() {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    TimeScale,
    BarElement,
    TimeSeriesScale,
    Title,
    Tooltip,
    Legend,
    annotationPlugin,
    Filler,
    ChartDataLabels
  );
  if (ChartJS.defaults.plugins.datalabels) {
    ChartJS.defaults.plugins.datalabels.display = false;
  }
  const verticalLinePlugin: Plugin<"line"> = {
    id: "verticalLinePlugin",
    afterDatasetsDraw(chart: Chart) {
      const activeElements = chart.tooltip?.getActiveElements();
      if (!activeElements || activeElements.length === 0) {
        return;
      }

      const activePoint = activeElements[0];
      const ctx = chart.ctx;
      const x = activePoint.element.x;
      const bottomY = chart.chartArea.bottom;
      const topY = chart.chartArea.top;

      ctx.save();
      ctx.beginPath();
      ctx.moveTo(x, bottomY);
      ctx.lineTo(x, topY);
      ctx.lineWidth = 1;
      ctx.strokeStyle = CHART_COLORS.CHART_VERTICAL_LINE;
      ctx.setLineDash([2, 3]);
      ctx.stroke();
      ctx.restore();
    },
  };

  Chart.register(verticalLinePlugin);
}
